import axios from 'axios';
import { API } from 'constants/api';
import { CAS_LANGUAGE_TOKENS_KEY, DEFAULT_LANG_TOKENS, TLangTokens } from './languageTokens.data';

export const setCasLanguageTokens = async (): Promise<void> => {
  try {
    await axios.get(API.initialize);
    const { data } = await axios.get(API.casLanguageTokens);
    localStorage.setItem(CAS_LANGUAGE_TOKENS_KEY, JSON.stringify(data));
  } catch (error) {
    localStorage.setItem(CAS_LANGUAGE_TOKENS_KEY, JSON.stringify(DEFAULT_LANG_TOKENS));
  }
};

export const getCasLanguageTokens = (): TLangTokens => {
  try {
    const tokens = localStorage.getItem(CAS_LANGUAGE_TOKENS_KEY);
    return tokens ? { ...DEFAULT_LANG_TOKENS, ...JSON.parse(tokens) } : DEFAULT_LANG_TOKENS;
  } catch {}

  return DEFAULT_LANG_TOKENS;
};
